<template>
  <div>
    <InputField
      v-for="(item) in list"
      :key="item.field"
      :type="item.type"
      :value="data[item.field]"
      :placeholder="item.placeholder"
      :label="item.label"
      :required="item.required"
      :readonly="item.readonly"
      :dateType="item.dateType"
      :maxlength="item.maxlength"
      :options="item.options"
      :disabled="item.disabled"
      :isNewAssembly="item.isNewAssembly"
      :align="item.align"
      :render="item.render"
      :rangeField="item.rangeField"
      :item="item"
      :data="data"
      @oninputchange="($event) => onChange({e: $event, field:item.field})"
      @onBlur="($event) => blur({e: $event, field:item.field})"
      @onFocus="($event) => focus({e: $event, field:item.field})"
    >
      <slot slot="button" :name="item.slot" :item="item" v-if="item.slot"></slot>
    </InputField>
  </div>
</template>

<script>
import InputField from '@components/InputField'

export default {
  name: 'formList',
  props: {
    list: {
      type: Array
    },
    data: {
      type: Object
    },
    onChange: {
      type: Function
    },
    onBlur: {
      type: Function
    },
    onFocus: {
      type: Function
    }
  },
  components: {
    InputField
  },
  watch: {
    data (v) {
      console.log(v)
    }
  },
  mounted () {
  },
  methods: {
    blur ({ e, field }) {
      if (this.onBlur) {
        this.onBlur({ e, field })
      }
    },
    focus ({ e, field }) {
      if (this.onFocus) {
        this.onFocus({ e, field })
      }
    }
  }
}
</script>
